import React from 'react';
import { MapPin } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="text-center text-stone-600 py-6 sm:py-8" role="contentinfo">
      <div className="flex items-center justify-center gap-2 mb-2">
        <MapPin className="w-4 h-4 sm:w-5 sm:h-5" aria-hidden="true" />
        <span className="text-sm sm:text-base font-semibold">Brno</span>
      </div>
      <p className="text-xs sm:text-sm mb-2 sm:mb-3">Hobby lovci kamenů</p>
      <p className="text-[10px] sm:text-xs text-stone-500 max-w-3xl mx-auto px-3 sm:px-4">
        tumbler · tromlovačka · půjčení tumbleru · půjčení tromlovačky · tromlování · leštění minerálů ·
        rotační tumbler · hobby tromlování · tromlování kamenů Brno · domácí tromlování minerálů ·
        leštění kamenů · tromlování šutrů · lortone tumbler · pronájem tromlovačky · výpůjčka tumbleru ·
        rock tumbler · rock polishing · minerály Brno
      </p>
      <p className="text-xs sm:text-sm mt-3 sm:mt-4 px-3 sm:px-4">
        © 2025 Tromluj! - Půjčovna rotačního tumbleru a tromlovačky v Brně
      </p>
    </footer>
  );
}
